import styles from './FinancialJob.module.scss';

import BackButton from "@src/components/_shared/BackButton";
import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import useRegistrationStore from "@src/stores/registrationStore";
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { Form, Formik } from 'formik';
import Input from '@src/components/_shared/UI/Input';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import ValidateChoiceButton from '@src/components/_shared/UI/ValidateChoiceButton';
import { useEffect, useState } from 'react';
import { companySchema } from '@src/utilities/schemas';
import useNavigationStore from '@src/stores/navigationStore';
import ListedCompany from './ListedCompany';
import { useMutation } from '@tanstack/react-query';
import { personUpdate } from '@src/api/Registration';
import Loader from '@src/components/_shared/UI/Loader';
import { handleApiError } from '@src/utilities/functions';

export default function FinancialJob() {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();
    const [worksInfinancial, setWorksInfinancial] = useState<boolean>(false);
    const [listedCompany, setListedCompany] = useState<boolean>(false);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);

    const { mutate, isPending } = useMutation({
        mutationFn: () => personUpdate({key: 'professional', value: registration.person.professional, is_psi: registration.partner_informations.is_partner, person_id: registration.person_id}), 
        onSuccess: () => setBlock('HomeAddress'),
        onError: (error: any) => handleApiError(error)
    });

    useEffect(() => {
        if (isSubmit) {
            mutate()
        }
        return () => {
            setIsSubmit(false)
        }
    }, [isSubmit])

    const _onGoBack = () => {
        setSection(2)
        setBlock('LegalAgentSituation')
    };

    const _onValidate = () => {
        setField('person.professional', { ...registration.person.professional, work_in_financial_past: true });
        setWorksInfinancial(true);
    }
    const _onDecline = () => {
        setField('person.professional', { ...registration.person.professional, work_in_financial_past: false });
        setWorksInfinancial(false);
        setListedCompany(true);
    }

    if (listedCompany) {
        return (
            <ListedCompany {...{setListedCompany, setIsSubmit, isPending}} />
        )
    }

    if (worksInfinancial) {
        return (
            <Container>
                <BackButton onClick={() => setWorksInfinancial(false)}/>
                <BlockTitle title="Dans quelle société ?" />
                <Subtitle content="Indiquez le nom de la société" />
                <Formik
                    initialValues={{
                        company_name: registration.person.professional.company_name,
                    }}
                    onSubmit={(values) => {
                        setField('person.professional', { ...registration.person.professional, company_name: values.company_name });
                        setListedCompany(true);
                        setWorksInfinancial(false);
                    }}
                    validationSchema={companySchema}
                >
                    {({ handleChange, handleSubmit, values, isValid, errors }) => {
                        return (
                            <Form id="companyNameForm" autoComplete="off" className="registerForm">
                                <Input
                                    title="Nom de la société"
                                    name="company_name"
                                    id="company_name"
                                    width="100%"
                                    type="text"
                                    placeholder="Ex: L'Oréal"
                                    value={values.company_name}
                                    onChange={handleChange('company_name')}
                                    clearInput={() => handleChange('company_name')('')}
                                    hasError={errors.company_name ? true : false}
                                    errorMessage={errors.company_name}
                                />
                                <ValidateButton title="Continuer" disabled={!isValid || !values.company_name} onClick={handleSubmit} />
                            </Form>
                        )
                    }}
                </Formik>
            </Container>
        )
    }

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Avez-vous travaillé dans le domaine financier ou boursier ?" />
            <Subtitle content="Pour des raisons légales veuillez indiquer si vous avez travaillé ou si vous travaillez toujours dans le domaine financier ou boursier " />
            {isPending ?
                <Loader type="SPINNER" />
                :
                <div className={styles.buttons}>
                    <ValidateChoiceButton title="Oui" selected={registration.person.professional.work_in_financial_past === true} onValidate={_onValidate} />
                    <ValidateChoiceButton title="Non" selected={registration.person.professional.work_in_financial_past === false} onValidate={_onDecline} />
                </div>
            }
        </Container>
    )
}
